import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from '@mui/material';

import Typography from '@mui/material/Typography';
import LinkMui from '@mui/material/Link';
import { Footer, FooterNavigation } from 'components/mui/Layouts/components/FooterWithTerms/StyledComponents';

import CircleIcon from '@mui/icons-material/Circle';

const FooterWithTerms: React.FC = () => {
  const { labelOptions } = useTheme();
  const { termsAndConditionLink, privacyLink } = labelOptions;

  return (
    <Footer>
      <FooterNavigation separator={<CircleIcon sx={{ fontSize: 3 }} color="primary" />}>
        {termsAndConditionLink && (
          <LinkMui
            color="primary.main"
            href={termsAndConditionLink}
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="auth.termsShort" defaultMessage="Terms and Conditions" />
          </LinkMui>
        )}

        {privacyLink && (
          <LinkMui color="primary.main" href={privacyLink} underline="hover" target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="auth.privacyPolicy" defaultMessage="Privacy Policy" />
          </LinkMui>
        )}
        <LinkMui
          color="primary.main"
          href={`mailto:${labelOptions.supportEmail}`}
          underline="hover"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="auth.support" defaultMessage="Support" />
        </LinkMui>
      </FooterNavigation>
      <Typography variant="inherit" component="span" sx={{ fontSize: 12 }} color="text.secondary" fontWeight="400">
        <FormattedMessage id="auth.cookies" defaultMessage="We use cookies to give you a better experience" />
      </Typography>
    </Footer>
  );
};

export default FooterWithTerms;
